import { render, staticRenderFns } from "./SalesOrderSingle.vue?vue&type=template&id=16809524&"
import script from "./SalesOrderSingle.vue?vue&type=script&lang=js&"
export * from "./SalesOrderSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports